import { createSlice } from '@reduxjs/toolkit';
import { abbreviate } from '../components/utils/utils';

const agentSlice = createSlice({
    name: 'agent',
    initialState: {
        name: "",
        status: "logout",
        shortExtension: "",
        photo: "",
        initials: "",
        duple: "",
        extension: "",
        userId: "",
        inbound: false,
        group: -1,
        party: "",
        partyName: "",
        groupName: "",
        functions: null,
        phoneStatus: "",
        previousPhoneStatus: "",
        callForm: "",
        chatForm: "",
        selectedForm: "",
        monitorToken: "",
        addressBookId: -1,
        contacts: [],
        tenantId: -1,
        wrapUpTime: 0,
        extraCallData: "",
        extraCallDataType: "",
        groupColor: "",
        monitorConnected: false,
        monitorConnectionLost: false
    },
    reducers: {
        acdEvent: (state, action) => {

            if (action.payload) {
                console.log("ACD event: ", action.payload);

                state.status = action.payload.acdStatus.toLowerCase();
                state.shortExtension = action.payload.association.shortExtension;
                state.name = action.payload.association.userName || action.payload.association.shortName
                state.reference = action.payload.association.reference;
                state.photo = action.payload.association.picture;
                state.duple = action.payload.association.duple;
                state.extension = action.payload.association.extension;
                state.userId = action.payload.association.userId;
                state.group = action.payload.group;
                state.groupName = action.payload.groupName;
                state.party = action.payload.party;
                state.partyName = action.payload.partyName;
                state.pause = action.payload.pause;
                state.initials = abbreviate(state.name);
                state.addressBookId = action.payload.association.addressBookCampaignId;
                state.contacts = action.payload.contacts;
                state.tenantId = action.payload.association.tenantId;
                state.wrapUpTime = action.payload.wrapUpTime;
                state.extraCallData = action.payload.extraCallData;
                state.extraCallDataType = action.payload.extraCallDataType;
                state.groupColor = action.payload.groupColor;

                localStorage.setItem("faExtension", action.payload.association.extension);
                localStorage.setItem("faFullUsername", action.payload.association.userName);
                localStorage.setItem("faAgtRef", action.payload.association.reference);

                let loggedIn = localStorage.getItem("fc-logged");
                let data = JSON.parse(loggedIn);
                data.shortExtension = action.payload.association.shortExtension;
                data = JSON.stringify(data);
                localStorage.setItem("fc-logged", data);
            }
        },
        setFunctions: (state, action) => {
            console.log("Functions: ", action.payload);

            if (action.payload != null) {
                state.functions = action.payload;
                localStorage.setItem("faDisabledNotifications", action.payload.disabledNotifications || "");
                localStorage.setItem("faPersistentNotifications", action.payload.persistentNotifications || "");
            }
        },
        setPhoneStatus: (state, action) => {
            console.log("CTI event: ", action.payload);

            if (state.phoneStatus != null)
                state.previousPhoneStatus = state.phoneStatus;

            if (action.payload)
                state.phoneStatus = action.payload;

            if (["TALKING", "HELD", "DIALING", "BUSY"].indexOf(state.phoneStatus.ctiStatus) > -1) {
                var then = new Date();
                then.setSeconds(then.getSeconds() - state.phoneStatus.time);
                state.phoneStatus.then = then.toISOString();
            }

            if (state.phoneStatus !== state.previousPhoneStatus) {

                let ctiEvent = {
                    Method: "CTIEvent",
                    Event: state.phoneStatus
                };
                Array.from(document.getElementsByTagName("iframe")).forEach(x => {
                    x.contentWindow.postMessage(ctiEvent, '*');
                });
            }
        },
        setCallForm: (state, action) => {
            state.callForm = action.payload;
        },
        setChatForm: (state, action) => {

            state.chatForm = action.payload
        },
        setSelectedForm: (state, action) => {

            state.selectedForm = action.payload
            console.log("selectedform" + state.selectedForm)
        },
        setMonitorToken: (state, action) => {
            state.monitorToken = action.payload
        },
        clearContacts: (state, action) => {
            state.contacts = [];
        },
        setContacts: (state, action) => {
            if (action.payload) {
                state.contacts = [];
                action.payload.forEach(c => {
                    c.contactId = parseInt(c.contactId);
                    state.contacts.push(c);
                });
            }
        },
        selectContact: (state, action) => {
            state.contacts = state.contacts.filter(x => parseInt(x.contactId) === action.payload);
        },
        setMonitorConnected: (state, action) => {
            state.monitorConnected = action.payload;
        },
        setMonitorConnectionLost: (state, action) => {
            state.monitorConnectionLost = action.payload;
        }
    }
});
export default agentSlice.reducer
export const { acdEvent, pausesList, setFunctions, setPhoneStatus, setCallForm, setChatForm,
    setSelectedForm, setMonitorToken, clearContacts, setContacts, selectContact, setMonitorConnected,
    setMonitorConnectionLost } = agentSlice.actions

